import { MakeEmbedWCCContentBlock } from 'components/content/mixins/embed';
import { DOMHelpers } from 'helpers/dom';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import WCCAttachment from 'models/attachments/attachment';
import { WCCContentBlock } from '../block/block';
import { WCCContentBlockConfig } from '../block/block.interfaces';

export interface WCCContentAttachmentsBlockConfig extends WCCContentBlockConfig {
    attachments: SubscribableOrNullableValue<Array<WCCAttachment>>
    columnWidth?: SubscribableOrNullableValue<number>
    rowsCount?: SubscribableOrNullableValue<number>
    expand?: SubscribableOrNullableValue<boolean>
    showTitle?: SubscribableOrNullableValue<boolean>
    showTranscript?: SubscribableOrNullableValue<boolean>
}

const ExtendedWCCContentBlock = [
    MakeEmbedWCCContentBlock()
].reduce((result, mixin) => mixin(result), WCCContentBlock);

export class WCCContentAttachmentsBlock extends ExtendedWCCContentBlock {
    attachments: Subscribable<Array<WCCAttachment>>
    columnWidth: Subscribable<number | undefined>
    rowsCount: Subscribable<number | undefined>
    expand: Subscribable<boolean | undefined>
    showTitle: Subscribable<boolean>
    showTranscript: Subscribable<boolean>

    constructor(config: WCCContentAttachmentsBlockConfig) {
        super(config);

        this.attachments = ko.flattenComputed(config.attachments, []);
        this.columnWidth = ko.flattenComputed(config.columnWidth);
        this.rowsCount = ko.flattenComputed(config.rowsCount);
        this.expand = ko.flattenComputed(config.expand);
        this.showTitle = ko.flattenComputed(config.showTitle, false);
        this.showTranscript = ko.flattenComputed(config.showTranscript, true);
    }

    protected override getNodes() {
        return [
            DOMHelpers.createComponent('wcc-content-attachments', { model: this })
        ]
    }
}